var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app-root" } },
    [
      _c(
        "a",
        {
          staticClass: "sr-only sr-only-focusable",
          attrs: { href: "#maincontent" }
        },
        [_vm._v(_vm._s(_vm.$t("Sr_ToMainContent")))]
      ),
      _vm._v(" "),
      _c("nav-menu", { attrs: { isInPrintMode: _vm.isInPrintMode } }),
      _vm._v(" "),
      _vm.showBanner
        ? _c("info-banner", {
            staticClass: "content-container",
            attrs: { banner: _vm.banner }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.alreadyApproved
        ? _c("cookie-consent-dialog", { attrs: { show: !_vm.isConsented } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.alreadyApproved
        ? _c("terms-of-use-dialog", {
            attrs: { loggedIn: true },
            on: {
              termsAccepted: _vm.onTermsAccepted,
              alreadyApproved: _vm.onAlreadyApprovedByUser
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showExtendSession
        ? _c("extend-session-dialog", {
            attrs: { warningXminBefore: _vm.sessionExpirationWarningBeforeMin },
            on: { continueLogin: _vm.onExtendSession }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-container pt-3", attrs: { id: "maincontent" } },
        [
          _vm.currentUser
            ? _c("router-view")
            : _c("div", [
                _vm._v("\n      " + _vm._s(_vm.$t("UserLoadError")) + "\n    ")
              ]),
          _vm._v(" "),
          _vm.showLoader
            ? _c("div", {
                attrs: { "aria-live": "polite", "aria-label": "Lataa" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("bounce-loader", {
            staticClass: "loader",
            attrs: { loading: _vm.showLoader, color: _vm.color, size: _vm.size }
          }),
          _vm._v(" "),
          _c("notifications", {
            attrs: {
              "aria-live": "polite",
              group: "global",
              position: "bottom right"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }